<template>
	<div class="custom_image_upload">
		<loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
		<CommonHead></CommonHead>

    <b-modal
      id="cart_notificaion"
      ref="cartmodal"
      :title="this.cartOrderMsg"
      title-tag="h3"
      ok-only
      modal-class="common_pop cart_notificaion"
    ></b-modal>

    <b-modal
      id="success-save-project"
      ref="successmodal"
      :title="this.successtitle"
      title-tag="h3"
      ok-only
      modal-class="common_pop save_project"
    >
    </b-modal>

    <!-- Save to projects pop up -->
    <b-modal
      id="saveto-project"
      ref="modal"
      title="Save to Projects"
      title-tag="h3"
      ok-only
      modal-class="common_pop saveto_project"
    >
      <div v-if="!showclient && !shownewproject && !shownewclient" class="projectoptions">
        <h3>Save to Projects</h3>
        <ul>
          <li>
            <a
              href="javascript:;"
              @click="showclient = !showclient"
            >Existing Client - Existing Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewproject = !shownewproject"
            >Existing Client - New Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewclient = !shownewclient"
            >New Client- New Project</a>
          </li>
        </ul>
      </div>
      <div v-if="showclient" class="savetoclient">
        <a @click="(showclient = !showclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to Existing Client- Project</h3>
        <b-form class="commonform" @submit="Submit1Popup">
          <div class="row">
            <div
              class="col"
              :state="!form1.errors.has('client')"
              :class="form1.errors.get('client')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('client')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('client')"
                  @input="form1.errors.clear('client'); getProjects();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form1.client"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('client')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject">
            <div
              class="col"
              :state="!form1.errors.has('project')"
              :class="form1.errors.get('project')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('project')"
            >
              <label class="setuplabel">Select a Project</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('project')"
                  @input="form1.errors.clear('project')"
                  :options="projects"
                  :reduce="projects => projects.value"
                  label="text"
                  v-model="form1.project"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('project')">Required Field</span>
              </div>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form1.error_name!=''">{{this.form1.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewproject" class="savetoclient">
        <a @click="(shownewproject = !shownewproject); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Project of Existing Client</h3>
        <b-form class="commonform" @submit="Submit2Popup">
          <div class="row">
            <div
              class="col"
              :state="!form2.errors.has('client_id')"
              :class="form2.errors.get('client_id')?'haserror forstar':'forstar'"
              :invalid-feedback="form2.errors.get('client_id')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form2.errors.has('client_id')"
                  @input="form2.errors.clear('client_id'); showProject1();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form2.client_id"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form2.errors.get('client_id')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject1">
            <div class="col">
              <md-field
                :state="!form2.errors.has('name')"
                :class="form2.errors.get('name')?'haserror forstar':'forstar'"
                :invalid-feedback="form2.errors.get('name')"
              >
                <label class="setuplabel">Create and save to new project</label>
                <md-input
                  :state="!form2.errors.has('name')"
                  @input="form2.errors.clear('name')"
                  v-model="form2.name"
                ></md-input>

                <span
                  class="error-msg"
                  v-if="form2.errors.get('name')"
                >{{form2.errors.get('name')=="The name field is required."?'Required Field':form2.errors.get('name')}}</span>
              </md-field>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form2.error_name!=''">{{this.form2.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewclient" class="savetoclient newcreation">
        <a @click="(shownewclient = !shownewclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Client- Project</h3>
        <b-form class="commonform" @submit="Submit3Popup">
          <md-field
            :state="!form.errors.has('createclient')"
            :class="form.errors.get('createclient')?'haserror forstar':'forstar'"
            :invalid-feedback="form.errors.get('createclient')"
          >
            <label>Create a new client</label>
            <md-input
              :state="!form.errors.has('createclient')"
              @input="form.errors.clear('createclient'); showProject2();"
              v-model="form.createclient"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createclient')"
            >{{form.errors.get('createclient')=="The createclient field is required."?'Required Field':form.errors.get('createclient')}}</span>
          </md-field>
          <md-field
            :state="!form.errors.has('createproject')"
            :class="form.errors.get('createproject')?'haserror forstar showProject2':'forstar showProject2'"
            :invalid-feedback="form.errors.get('createproject')"
          >
            <label>Create a new project</label>
            <md-input
              :state="!form.errors.has('createproject')"
              @input="form.errors.clear('createproject')"
              v-model="form.createproject"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createproject')"
            >{{form.errors.get('createproject')=="The createproject field is required."?'Required Field':form.errors.get('createproject')}}</span>
          </md-field>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form.error_name!=''">{{this.form.error_name}}</span>
        </b-form>
      </div>
    </b-modal>
		<div class="container container-desktop">
			<b-breadcrumb :items="breadcrumb"></b-breadcrumb>
			<div v-if="customPrintImageUpload.length != 0">
				<div class="row my-5">
					<div class="col-lg-12 col-xl-6 sigleproduct">
						<div class="singlecontent">
							<h2>Your Image</h2>
							<a href="javascript:void(0)" class="ml-auto text-dark delbtnicon" @click="customPrintImageDelete(customPrintImageUpload.id)">
								<svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="18.582" viewBox="0 0 17.5 18.582">
                  <g id="DELETE" transform="translate(-13.877 0.449)">
                    <g id="Group_16" data-name="Group 16" transform="translate(13.877 -0.449)">
                      <path id="Path_5" data-name="Path 5" d="M76.381,83.017H71.928c-1.539,0-3.074.026-4.612,0h-.063c-.1-.007-.074,0,.052.011,0,0-.119-.026-.112-.022a.831.831,0,0,0-.138-.037c-.1-.007.171.1.022.007a.9.9,0,0,1-.1-.056c-.178-.1-.011.007-.007,0s-.2-.178-.2-.2.1.171.022.015c-.022-.041-.045-.082-.067-.119-.082-.145.03.045.015.052s-.045-.149-.052-.16a.539.539,0,0,0-.022-.112c.071.19.011.074.011-.007V73.9c0-1.424.033-2.854,0-4.278v-.067l-.847.847h12l-.847-.847V82.459c0,.2.052-.182,0,0a.941.941,0,0,1-.059.216c.011-.033.03-.067.041-.1a.8.8,0,0,1-.052.1,1.022,1.022,0,0,1-.089.141l.063-.085c-.026.03-.045.056-.071.082a.777.777,0,0,1-.082.074c-.067.059-.056.045.041-.03a.935.935,0,0,1-.141.089c-.033.015-.063.033-.1.052.119-.045.13-.056.045-.026-.056.011-.112.03-.167.041-.093.015-.074.011.056-.007a.365.365,0,0,1-.1.007.847.847,0,0,0,0,1.695A2.344,2.344,0,0,0,78.692,82.4c0-.152,0-.308,0-.461V69.547a.862.862,0,0,0-.847-.847h-12a.864.864,0,0,0-.847.847V82.366a2.321,2.321,0,0,0,.821,1.791,2.464,2.464,0,0,0,1.6.55h8.965a.854.854,0,0,0,.847-.847.864.864,0,0,0-.851-.844Z" transform="translate(-63.1 -66.13)" fill="#313233"/>
                      <path id="Path_6" data-name="Path 6" d="M14.726,69.324H28.582c.639,0,1.282.015,1.922,0h.026a.854.854,0,0,0,.847-.847.864.864,0,0,0-.847-.847H16.673c-.639,0-1.282-.015-1.922,0h-.026a.847.847,0,0,0,0,1.695Z" transform="translate(-13.877 -65.092)" fill="#313233"/>
                      <path id="Path_7" data-name="Path 7" d="M148.652,2.932V1.441c0-.033.022-.115-.007,0-.033.141.011-.041.015-.056.03-.141-.082.115,0,0a.949.949,0,0,1,.059-.093c.015.007-.123.123-.045.063a.468.468,0,0,0,.074-.074c.059-.074-.056.063-.063.045a.321.321,0,0,1,.071-.041c.149-.082.011.015-.026,0,.011,0,.268-.071.111-.033-.111.03-.03,0,.007.007h3.75c.052,0,.1,0,.149,0a.359.359,0,0,0,.063,0c-.037.037-.175-.037-.056,0l.082.022c.1.015-.13-.085-.045-.022a.438.438,0,0,0,.071.037c.022.011.112.045,0,0s.007.015.037.041.041.085,0,0c-.056-.119.007.026.026.052.041.063-.007.056,0,0-.026-.067-.03-.067,0,0,0,.015.007.037.011.056.045.152,0-.167,0,.007v1.49a.854.854,0,0,0,.847.847.864.864,0,0,0,.847-.847V2A3.161,3.161,0,0,0,154.487.72a1.914,1.914,0,0,0-1.751-1.167c-.2,0-.409,0-.61,0h-2.412a2.708,2.708,0,0,0-2.263.613,1.947,1.947,0,0,0-.494,1.275c0,.13,0,.268,0,.4V2.932a.847.847,0,0,0,1.695,0Z" transform="translate(-142.009 0.449)" fill="#313233"/>
                      <path id="Path_8" data-name="Path 8" d="M176.1,174.826v6.489a.854.854,0,0,0,.847.847.864.864,0,0,0,.847-.847v-6.489a.854.854,0,0,0-.847-.847A.867.867,0,0,0,176.1,174.826Z" transform="translate(-170.071 -167.494)" fill="#313233"/>
                      <path id="Path_9" data-name="Path 9" d="M276.8,174.826v6.489a.854.854,0,0,0,.847.847.864.864,0,0,0,.847-.847v-6.489a.854.854,0,0,0-.847-.847A.864.864,0,0,0,276.8,174.826Z" transform="translate(-267.028 -167.494)" fill="#313233"/>
                    </g>
                  </g>
                </svg>
							</a>
							<img class="mt-3 custom-image-fluid" :src="`/shop/CustomPatterns/large/${customPrintImageUpload.image_name}`" alt="image">
							<div class="ml-auto mt-3">
								<p>{{ imageDimension }}</p>
							</div>
						</div>
					</div>
					<div class="col-lg-12 col-xl-6 sigleproduct">
						<div class="singlecontent">
							<h2>Custom Print</h2>
							<div class="pricesection" v-if="user.id > 0"> 
								<div class="samediv">
									<span>Retail Price :</span>
									<p>$ {{ computedPrice(2) }} / {{info.UNITID}}</p>
								</div>
								<div class="samediv" v-if="user.setting_retail === false">
									<span>Wholesale Price :</span>
									<p>$ {{ computedPrice() }} / {{info.UNITID}}</p>
								</div>
								<div class="samediv">
									<span>Total Qty on Hand: </span>
									<p class="d-flex">
                    Custom printed in the USA by
                    <b-img
                      class="d-inline color-works-image"
                      src="/shop/images/colorworks_black.svg"
                      fluid
                      alt="colorworks"
                    ></b-img> 
                  </p>
								</div>
							</div> 
							<div class="detailed-options">
			  				<ul class="new_ul">
									<li class="diff_li">
										<div class="fixedbar">
											<div class="container">
												<b-form class="addcartform commonform" @submit="onSubmit" v-if="user.id > 0">
													<div class="afterlogin">
														<div
															class="ordertype type"
															:state="!cartform.errors.has('order_type')"
															:class="cartform.errors.get('order_type')?'haserror forstar':'forstar'"
															:invalid-feedback="cartform.errors.get('order_type')"
														>
                              <input
                                type="text"
                                placeholder="Please Select Order Type"
                                :value="cartform.order_type"
                                disabled
                                class="order-type-input"
                              >
														</div>
														<div class="samediv quantity">
															<div class="qtydiv">
																<span @click="decrement()">-</span>
																<input v-model.number="cartform.quantity" min="1" type="number" @input="handleInput" step=".01"/>
																<span @click="increment()" class="lastspan">+</span>
															</div>
														</div>
														<div class="ordertype yard">
															<v-select
																:options="yard"
																v-model="cartform.unitid"
																:clearable="false"
																:searchable="false"
																placeholder="yd"
															></v-select>
														</div>
														<div class="requiredcut bsbox" v-if="user.id > 0">
															<input class="basestyle" type="text" :value="basefabricname" readonly @click="getBaseFabrics" placeholder="Please Select Base Fabric" />
                              <span class="error-msg basestyle-error d-none">Required Field</span>
                              <img src="/shop/images/edit.svg" alt="Edit image" class="edit-alt" @click="getBaseFabrics">
                              <input type="text" v-model="cartform.notes" :class="info.COLORWORKS == '1'?'cartformnotes bsstyle':'cartformnotes'" placeholder="Required Cuts if known:" />
                            </div>
                            <div class="requiredcut basefabricimg" v-if="basefabricname != ''">
                              <img :src="basefabricimage" alt="Edit image" class="img-fluid">
                            </div>
														<div class="barbuttons">
															<input type="hidden" v-model="cartform.user_id" />
															<input type="hidden" v-model="cartform.itemid" />
															<input type="hidden" v-model="cartform.pc_type" />
															<input type="hidden" v-model="cartform.inventcolorid" />
															<b-button type="submit" class="AddTOCartBtn" variant="dark">Add to cart</b-button>
															<b-button @click="Showsavetoproject" variant="outline-primary">
																<b-img class="saveproject" src="/shop/images/bookmark.svg" fluid alt="save image"></b-img>
																<b-img
																class="saveproject white"
																src="/shop/images/bookmark-white.svg"
																fluid
																alt="save image"
																></b-img>Save to Projects
															</b-button>
														</div>
                            <p v-if="info.COLORWORKS == '1'" class="noti_msg_btm">Custom printed fabrics typically ship within 7 business days. All sales are final. Returns will only be granted for flawed or damaged goods. To learn more about ColorWorks&trade; custom digital printing <a href="/colorworks">click here.</a></p>
                            <a v-if="info.COLORWORKS == '1'" href="/shop/sample/RMC 21BF" target="_blank" class="cwsampledeck"><b-img src="/shop/images/cw-sample.png" fluid alt="ColorWorks Sample deck image"></b-img></a>
													</div>
												</b-form>
											</div>
										</div>
									</li>
								</ul>
							</div>
              <!-- NOTE: All sales of custom printed fabrics are final. Custom printed fabrics are not eligible for refunds, exchanges and returns. We strongly recommand ordering a sample prior to ordering yardage. -->
						</div>
					</div>
        </div>
        <div class="my-5">
          <div class="col-lg-12 col-xl-12 notifydesc">
            <p>Please note that your uploaded image will be printed in repeat <i>as is</i>. If you are not satisfied with the 1 yard preview provided below, cancel this order and email colorworks@rmcoco.com for assistance.</p>
          </div>
        </div>
        <hr class="my-7">
        <div class="custom-image-repeat-block mb-5">
          <div class="mb-3 d-flex">
            <h2>Your Image in Repeat (1 Full Yard)</h2>
            <p>**This is visual representation. The actual size may vary</p>
          </div>
          <div class="canvaswrap">
            <canvas id="device" width="8100" height="5400"></canvas>
            <div class="inches v-36">36"</div>
            <div class="inches h-0">0"</div>
            <div class="inches v-0">0"</div>
            <div class="inches h-54">54"</div>
          </div>
				</div>
			</div>
		</div>
    <div class="container container-mobile d-flex justify-content-center align-items-center my-5">
			<h4>OOPS! This page is not available for mobile devices. Plase access via desktop or laptop</h4>
		</div>
		<div class="basestyle-backdrop bg-dark" v-if="basestyleshow == true" @click="closeBaseFabrics"></div>
    <div class="basestylecontainer" v-if="basestyleshow == true">
      <div class="row my-5">
        <h3 class="mx-auto pl-65 basecotainertitle">Select a Fabric</h3>
        <b-img
          class="mr-5 basestylecontainer-close-icon"
          src="/shop/images/close.svg"
          fluid
          alt="close image"
          @click="closeBaseFabrics"
        ></b-img>
      </div>
      <perfect-scrollbar :suppressScrollX="false">
        <SKLoader :repeat="5" :loading="isLoadingBase" speed="1s" class="baseloadercont">
          <SKBaseFabrics/>
        </SKLoader>
        <template v-if="baseFabrics.length > 0 && isLoadingBase == false">
          <template v-for="(baseFabric, i) in baseFabrics">
            <div class="p-3" :key="i">
              <div class="row mb-5">
                <div class="col-5">
                  <b-img :src="baseFabric.URL" fluid></b-img>
                </div>
                <div class="col-7">
                  <h3 class="text-left mb-3 basefabricname">
                    {{ baseFabric.NAME }}
                  </h3>
                  <p>Price: 
                    <span class="font-weight-normal">
                      $ {{ parseFloat(baseFabric.AMOUNT).toFixed(2) }} / per yd
                    </span>
                  </p>
                  <p class="basefabricdescrip">{{ baseFabric.RMC_BaseFabricDesc }}</p>
                  <hr>
                  <div class="accordion">
                    <a class="text-decoration-none" href="javascript:;" v-b-toggle="'collapse-' + i">
                      Specifications
                    </a>
                    <div class="specification mt-3">
                      <div class="spec_cont">
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Width:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWidth != '' ? parseFloat(baseFabric.RMC_BaseFabricWidth).toFixed(2) : "-" }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Weight:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWeight != '' ? parseFloat(baseFabric.RMC_BaseFabricWeight).toFixed(2) : '' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Content:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricContent != '' ? baseFabric.RMC_BaseFabricContent : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Country:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.LogisticsAddressCountryRegionId != '' ? baseFabric.LogisticsAddressCountryRegionId : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Wyzenbeek:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWyzenbeek != '' ? baseFabric.RMC_BaseFabricWyzenbeek : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Martindale:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricMartindale != '' ? baseFabric.RMC_BaseFabricMartindale : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>CleaningCode:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.CleaningCode != '' ? baseFabric.CleaningCode : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Test Code:</span>
                          </div>
                          <div class="txtspec">
                            <p>
                              {{ baseFabric.rmcFireTestCode1 != '' ? baseFabric.rmcFireTestCode1 : '-' }},
                              {{ baseFabric.rmcFireTestCode2 != '' ? baseFabric.rmcFireTestCode2 : '-' }},
                              {{ baseFabric.rmcFireTestCode3 != '' ? baseFabric.rmcFireTestCode3 : '-' }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <button class="btn btn btn-outline-primary fabricSelectBtn" @click="baseFabricSelected(baseFabric)">SELECT</button>
                </div>
              </div>
              <hr>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-center">
            <h3 class="mt-5">No Fabric Found. </h3>
          </div>
        </template>
      </perfect-scrollbar>
    </div>
		<CommonFoot></CommonFoot>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import SKBaseFabrics from "@/views/skeletons/SKBaseFabrics";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

export default {
	components: {
		CommonHead,
		CommonFoot,
		Loading,
    SKBaseFabrics,
		"v-select": vSelect,
	},
	 metaInfo: {
    title: 'RM COCO | Custom Print Image Upload',
    meta: [{
        name: 'description',
        content: 'Custom print image upload.'
    }],
  },
	data() {
		return {
			isLoading: false,
      isLoadingBase: false,
			itemId: "CW000",
			inventColorId: "",
      pcType: "fabric",
			customPrintImageUpload: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Custom Prints',
					href: '/'
				},
				{
					text: 'Upload Image',
					active: true
				}
			],
			cartform: new Form({
				itemid: "CW000",
				inventcolorid: "",
				pc_type: "fabric",
				unitid: "yd",
				order_type: "regular",
				quantity: 1,
				notes: "",
				user_id: "",
        basestyle:"",
        basefabricname: "",
				baseprice:0,
				discountedprice:0,
        custom_print_image_id: this.$route.params.id
			}),
      form: new Form({
        createclient: "",
        createproject: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
        error_name: "",
        inventstyleid: "",
        basefabricname: "",
        custom_print_image_id: this.$route.params.id
      }),
      form1: new Form({
        client: "",
        project: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        cart: "",
        user_id: "",
        error_name: "",
        inventstyleid: "",
        basefabricname: "",
        custom_print_image_id: this.$route.params.id
      }),
      form2: new Form({
        client_id: "",
        name: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        cart: "",
        user_id: "",
        error_name: "",
        inventstyleid: "",
        basefabricname: "",
        custom_print_image_id: this.$route.params.id
      }),
      showclient: false,
      shownewproject: false,
      shownewclient: false,
      basefabricimage:"",
			orderstype: [
				{ value: "regular", text: "Regular" },
			],
      clientscart: [
        { value: "1", text: "James" },
        { value: "2", text: "Mathew" },
        { value: "3", text: "John" },
        { value: "4", text: "Nick" }
      ],
      projects: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ],
      saveprojectcart: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ],
			info: {
				MINPRICE: 0,
				MAXPRICE: 0,
				COLORWORKS: "1",
				PRICE:0,
				UNITID: 'yd',
        PRODUCTTYPE: 'fabric'
			},
			yard: ["yd"],
			minicart: {
        items: []
      },
			basestyleshow: false,
			baseFabrics: [],
			selectedBaseFabric: [],
      cartOrderMsg: "",
      successtitle: "",
      imageDimension: ""
		}
	},
	computed: {
    ...mapGetters(["user"]),
		basefabricname() {
      if (Object.keys(this.selectedBaseFabric).length > 0) {
        return this.selectedBaseFabric.NAME;
      }
      return '';
    }
	},
	mounted() {
    if (!this.user) {
			this.$router.push({ name: 'login'});
		}
		// this.fetchProduct();
		this.getProductMinMaxPrice();
		this.fetchData();
    this.LoadClients();
    this.isLoadingBase = true;
		this.$store.dispatch('getProductBaseFabrics', {
			itemId: this.itemId,
			inventColorId: this.inventColorId,
		}).then(baseFabrics => {
      let data  = baseFabrics.data.sort(function(a, b){
        return a.AMOUNT - b.AMOUNT;
      });
			this.baseFabrics = data;
      this.isLoadingBase = false;
		});
	},
	hideModal() {
    this.$refs["modal"].hide();
  },
	methods: {
    canvasImage(){
      var canvas = document.getElementById("device"),
          context = canvas.getContext("2d"),
          img = new Image();

      img.src = '/shop/CustomPatterns/original/'+this.customPrintImageUpload.image_name;
      img.onload = function(){
          // create pattern
          var ptrn = context.createPattern(img, 'repeat'); // Create a pattern with this image, and set it to "repeat".
          context.fillStyle = ptrn;
          context.fillRect(0, 0, canvas.width, canvas.height); // context.fillRect(x, y, width, height);
      }
 		},
		getBaseFabrics(){
      this.basestyleshow = true;
    },
    closeBaseFabrics() {
      this.basestyleshow = false;
    },
    baseFabricSelected(fabric) {
      $(".requiredcut > .basestyle").removeClass("border-danger");
      $(".basestyle-error").addClass('d-none');
      this.selectedBaseFabric = fabric;
      this.basestyleshow = false;
      this.cartform.basestyle = fabric.INVENTSTYLEID;
      this.cartform.basefabricname = fabric.NAME;
      this.cartform.baseprice = fabric.AMOUNT;
      this.basefabricimage = fabric.URL;
    },
    computedPrice(multi = 1) {
      let price = '';
      if (Object.keys(this.selectedBaseFabric).length > 0) {
        price = parseFloat(this.selectedBaseFabric.AMOUNT * multi).toFixed(2);
      } else {
        price = `${parseFloat(this.info.MINPRICE * multi).toFixed(2).toString()} - $ ${parseFloat(this.info.MAXPRICE * multi).toFixed(2).toString()}`;
      }
      return price;
    },
		getProductMinMaxPrice() {
			this.$store
				.dispatch("getProductMinMaxPrice", {
					itemId: this.itemId,
					inventColorId: this.inventColorId
				})
				.then(product => {
					this.info.MINPRICE = product.data.minprice,
					this.info.MAXPRICE = product.data.maxprice
				});
		},
		CheckCartOrderType() {
      $(".ordertype.type .error-msg").remove();
      $(".AddTOCartBtn").attr("disabled", true);
      $(".AddTOCartBtn").css("cursor", "default");
      if (this.cartform.order_type.toLowerCase() == "memo") {
        $(".samediv.quantity, .ordertype.yard").css("display", "none");
        this.cartform.quantity = 1;
      } else {
        $(".samediv.quantity, .ordertype.yard").css("display", "block");
      }
      this.$store
        .dispatch("loadCart", this.user.accountnumber)
        .then(minicart => {
          this.minicart.items = minicart.data.ITEMS;

          if (minicart.data.ITEMS.length > 0) {
            if (minicart.data.ITEMS[0].ORDERTYPE != this.cartform.order_type) {
              this.cartOrderMsg =
                this.cartform.order_type.toUpperCase() +
                " orders cannot be placed with " +
                minicart.data.ITEMS[0].ORDERTYPE.toUpperCase() +
                " orders. Please finish placing your " +
                minicart.data.ITEMS[0].ORDERTYPE.toUpperCase() +
                " order and then place your " +
                this.cartform.order_type.toUpperCase() +
                " order separately.";

              $(".AddTOCartBtn").attr("disabled", true);
              $(".AddTOCartBtn").css("cursor", "default");

              this.$refs["cartmodal"].show();
            } else {
              this.cartOrderMsg = "";
              $(".AddTOCartBtn").removeAttr("disabled");
              $(".AddTOCartBtn").css("cursor", "pointer");
            }
          }else{
              $(".AddTOCartBtn").removeAttr("disabled");
              $(".AddTOCartBtn").css("cursor", "pointer");
          }
        });
    },
		fetchData() {
			this.isLoading = true;
			this.$store.dispatch('getCustomImageUpload', this.$route.params.id).then(res => {
				this.isLoading = false;
				if (Object.keys(res.data).length) {
					this.customPrintImageUpload = res.data;

          if (this.customPrintImageUpload) {
            let img = new Image();
            img.onload = () => {
              let width = parseFloat(img.width/150).toFixed(2);
              let height = parseFloat(img.height/150).toFixed(2);
              this.imageDimension = `${width}" X ${height}"`;
            }
            img.src = `/shop/CustomPatterns/original/${this.customPrintImageUpload.image_name}`;
            setTimeout(() => this.canvasImage(), 200);
          }
				} else {
					this.$router.push({ name: '404'});
				}
			});
		},
		customPrintImageDelete(id) {
			this.isLoading = true;
			this.$store.dispatch('customPrintImageDelete', id).then(res => {
				this.isLoading = true;
				this.$notify({
					text: "Image deleted successfully.",
					type: "success"
				});
				this.$router.push({ name: 'custom-print-image-upload'});
			}); 
		},
		getPDF() {
      this.$store
        .dispatch("loadProductPDF", {
          itemid: this.itemId,
          inventcolorid: this.inventColorId
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "product.pdf");
          document.body.appendChild(link);
          link.click();
        });
    },
		increment() {
      let currentqty = Number(this.cartform.quantity) + 1;
      this.cartform.quantity = Number(currentqty).toFixed(2);
    },
		decrement() {
			if (this.cartform.quantity <= 1) {
				this.$notify({
          text: "0 Quantity not allowed",
          type: "error"
        });
			} else {
				let currentqty = Number(this.cartform.quantity) - 1;
				this.cartform.quantity = Number(currentqty).toFixed(2);
			}
    },
		handleInput(e){
      let stringValue = e.target.value.toString();
      let regex = /^\d*(\.\d{1,2})?$/
      if(!stringValue.match(regex) && this.cartform.quantity!== '') {
        this.cartform.quantity = this.previousPrice;
      }
      this.previousPrice = this.cartform.quantity;
    },
		onSubmit(evt) {
      evt.preventDefault();

      this.cartform.user_id = this.user.accountnumber;
      if (Object.keys(this.selectedBaseFabric).length == 0) {
        this.cartform.baseprice = this.info.PRICE;
      }
      // this.cartform.discountedprice = this.info.DISCOUNTPRICE;
      var submit = 1;
      if(this.cartform.order_type ==""){
        submit = 0;
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").css("border-color","#f00");
        if($(".ordertype.type .error-msg").length == 0){
          $(".ordertype.type").append(
            "<span class='error-msg'>Required Field</span>"
          );
        }
        return false;
      }else{
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").removeAttr("style");
      }

      if(this.user.id > 0 && this.info.COLORWORKS == '1'){
        if (Object.keys(this.selectedBaseFabric).length > 0) {
          $(".requiredcut > .basestyle").removeClass("border-danger");
          $(".basestyle-error").addClass('d-none');
        } else{
          submit = 0;
          $(".requiredcut > .basestyle").addClass("border-danger");
          $(".basestyle-error").removeClass('d-none');
          return false;
        }
      }
			if (submit == 1) {
				this.isLoading = true;
				this.$store
					.dispatch("AddtoCart", {
						form: this.cartform
					})
					.then(rsdata => {
						if(rsdata.data.success == false){
							this.cartOrderMsg = rsdata.data.message;
							this.$refs["cartmodal"].show();
							this.isLoading = false;
						}else{
						this.$notify({
							text: "Product added to cart",
							type: "success"
						});
            this.selectedBaseFabric = [];
						this.isLoading = true;
						this.cartform.order_type = "regular";
						this.$store
							.dispatch("loadCart", this.user.accountnumber)
							.finally(() => {
								this.isLoading = false;
							});
						//reset form 
						}
					})
					.catch(error => {
						this.isLoading = false;
						if (this.cartform.hasErrors()) {
							this.$notify({
								text:
									"There is a validation error. Please correct the fields outlined in red and try again.",
								type: "error"
							});
						} else {
							this.$notify({
								text: "Something went wrong!",
								type: "error"
							});
						}
					});
			}
		},
		Showsavetoproject() {
      let saveToProject = false;

      if (this.cartform.order_type) {
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").removeAttr("style");
        saveToProject = true;
      } else if($(".ordertype.type .error-msg").length == 0){
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").css("border-color","#f00");
        $(".ordertype.type").append(
          "<span class='error-msg'>Required Field</span>"
        );
        saveToProject = false;
      }

      if(this.user.id > 0 && this.info.COLORWORKS == '1'){
        if (Object.keys(this.selectedBaseFabric).length > 0) {
          saveToProject = true;
          $(".requiredcut > .basestyle").removeClass("border-danger");
          $(".basestyle-error").addClass('d-none');
        } else{
          saveToProject = false;
          $(".requiredcut > .basestyle").addClass("border-danger");
          $(".basestyle-error").removeClass('d-none');
        }
      }

      if(saveToProject){
        this.resetModelForm();
        this.$refs["modal"].show();
      }
    },
		resetModelForm() {
      $(".ordertype.type .error-msg").remove();
      $(".savetoclient .error-msg").remove();
      this.showclient = false;
      this.shownewproject = false;
      this.shownewclient = false;
      //reset forms
      this.form.createclient = "";
      this.form.createproject = "";
      this.form.product_id = "";
      this.form.inventcolorid = "";
      this.form.pc_type = "";
      this.form.order_type = "";
      this.form.notes = "";
      this.form.quantity = "";
      this.form.user_id = "";
      this.form.cart = "";
      this.form.error_name = "";

      this.form1.client = "";
      this.form1.project = "";
      this.form1.product_id = "";
      this.form1.inventcolorid = "";
      this.form1.pc_type = "";
      this.form1.order_type = "";
      this.form1.notes = "";
      this.form1.quantity = "";
      this.form1.user_id = "";
      this.form1.cart = "";
      this.form1.error_name = "";

      this.form2.client_id = "";
      this.form2.name = "";
      this.form2.product_id = "";
      this.form2.inventcolorid = "";
      this.form2.pc_type = "";
      this.form2.order_type = "";
      this.form2.notes = "";
      this.form2.quantity;
      this.form2.user_id = "";
      this.form2.cart = "";
      this.form2.error_name = "";
    },
    getProjects() {
      if (this.form1.client) {
        $(".showProject").show();
        this.$store
          .dispatch("LoadClientProjects", this.form1.client)
          .then(loadprojects => {
            this.projects = loadprojects.data;
          });
      } else {
        $(".showProject").hide();
      }
    },
    showProject1() {
      if (this.form2.client_id) {
        $(".showProject1").show();
      } else {
        $(".showProject1").hide();
      }
    },
    showProject2() {
      if (this.form.createclient) {
        $(".showProject2").show();
      } else {
        $(".showProject2").hide();
      }
    },
    LoadClients() {
      if (this.user.id > 0) {
        this.$store
          .dispatch("LoadClient", this.user.accountnumber)
          .then(loadclients => {
            this.clientscart = loadclients.data;
          });
      }
    },
    statusTooltip(ABCCODEVALUE) {
      let str = "";
      if (ABCCODEVALUE == "M" || ABCCODEVALUE == "P") {
        str =
          "Discount applies to current stock only. Mill may have additional yardage, but must take entire minimum order quantity at regular price. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "XM" || ABCCODEVALUE == "XP") {
        str =
          "Item is discontinued by mill, discount applies to current stock only. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "X") {
        str = "Item is discontinued by mill, no discount is offered. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "Z") {
        str =
          "Closeout item, no new orders accepted. Discount applies to current stock only. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "XZ") {
        str =
          "Closeout item also discontinued by mill, discount applies to current stock only. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      return str;
    },
    Submit1Popup(evt) {
      evt.preventDefault();

      this.form1.product_id = this.itemId;
      this.form1.inventcolorid = this.inventcolorid;
      this.form1.inventstyleid = this.cartform.basestyle;
      this.form1.basefabricname = this.cartform.basefabricname;
      this.form1.pc_type = this.pcType;
      this.form1.order_type = this.cartform.order_type;
      this.form1.notes = this.cartform.notes;
      this.form1.quantity = this.cartform.quantity;

      this.isLoading = true;
      this.$store
        .dispatch("AddProductToProject", {
          form: this.form1
        })
        .then(response => {
          if (response.data.success) {
            this.form1.error_name = "";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
           /* this.form1 = new Form({
              client: null,
              project: null,
              error_name: ""
            });*/
            this.form1.client= null;
            this.form1.project= null;
            this.form1.error_name= "";

            this.$refs["popupmodal"].hide();
            this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form1.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    Submit2Popup(evt) {
      evt.preventDefault();

      this.form2.product_id = this.itemId;
      this.form2.inventcolorid = this.inventcolorid;
      this.form2.inventstyleid = this.cartform.basestyle;
      this.form2.basefabricname = this.cartform.basefabricname;
      this.form2.pc_type = this.pcType;
      this.form2.order_type = this.cartform.order_type;
      this.form2.notes = this.cartform.notes;
      this.form2.quantity = this.cartform.quantity;

      this.isLoading = true;
      this.$store
        .dispatch("AddProject", {
          form: this.form2
        })
        .then(response => {
          if (response.data.success) {
            this.form2.error_name = "";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
           /* this.form2 = new Form({
              client_id: null,
              name: null,
              error_name: ""
            });*/
            this.form2.client_id= null;
            this.form2.name= null;

            this.$refs["popupmodal"].hide();
            this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form2.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    Submit3Popup(evt) {
      evt.preventDefault();

      this.form.product_id = this.itemId;
      this.form.inventcolorid = this.inventcolorid;
      this.form.inventstyleid = this.cartform.basestyle;
      this.form.basefabricname = this.cartform.basefabricname;
      this.form.pc_type = this.pcType;
      this.form.order_type = this.cartform.order_type;
      this.form.notes = this.cartform.notes;
      this.form.quantity = this.cartform.quantity;
      this.form.user_id = this.user.accountnumber;

      this.isLoading = true;
      this.$store
        .dispatch("AddClientAndProject", {
          form: this.form
        })
        .then(response => {
          if (response.data.success) {
            //update clients dropdown
            this.LoadClients();
            this.form.error_name = "";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
          /*  this.form = new Form({
              createclient: null,
              createproject: null,
              error_name: ""
            });*/

            this.form.createclient= null;
             this.form.createproject= null;
             this.form.error_name= "";

            this.$refs["popupmodal"].hide();
            this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
	}
}
</script>
<style scoped>
  .my-7{
    margin: 7rem 0 !important;
  }
  .detailed-options ul.new_ul > li:last-child{
    border-bottom: 0 !important;
  }
  .basestyle-backdrop {
    left: 0;
    z-index: 11;
    width: 100vw;
    opacity: .6;
    position: fixed;
    top: 0;
    height: 100vh;
  }
  .basestylecontainer h3.basecotainertitle {
    font-size: 22px !important;
  }
  .basestylecontainer h3.basefabricname {
    font-size: 17px !important;
  }
  .basestylecontainer .fabricSelectBtn{
    width: 100px;
  }
  .basestylecontainer .basestyleaddicon{
    height: 11px;
    width: 11px;
    float: right;
    margin-top: 5px;
  }
  .basestylecontainer .accordion a {
    font-weight: 500;
    font-size: 15px;
    color: #303030;
    width: 100%;
    display: inline-block;
  }
  .singlecontent{
    width: 100%;
    max-width: 100%;
  }
  .singlecontent .delbtnicon{
    background: #ececec;
    padding: 1rem;
    border-radius: 5px;
  }
  .pl-65{
    padding-left: 65px !important;
  }

  .basestylecontainer-close-icon{
    width: 13.71px;
    height: 13.71px;
    margin-bottom: 4px;
    cursor: pointer;
  }

  .color-works-image{
    width:80px;
    position: relative;
    bottom: 5px;
  }

  .container-mobile{
	  display: none !important;
  }

  .row .col-lg-12 {
    -webkit-box-flex: 0;
    flex: 0 0 50%;
	  max-width: 50%;
  }
  .col-lg-12.notifydesc{
    width: 100%;
    max-width: 100%;
    background: #f00;
    color: #fff;
    text-align: center;
    padding: 20px 30px;
  }
  .col-lg-12.notifydesc p{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .sigleproduct .fixedbar .AddTOCartBtn {
    width: 48.8% !important;
  }

  .sigleproduct .fixedbar .barbuttons { 
    width: 100%;
  }

  .sigleproduct .custom-image-fluid {
    width: 100%;
    height: auto;
  }

  .custom_image_upload .image-repeat {
    background-repeat:repeat;
    width: 985px;
    height: 657px;
    background-size:16.67%;
  }

  .order-type-input {
    width: 100%;
    height: 40px;
    font-size: 12px;
    color: #777777;
    padding: 5px 20px;
    box-sizing: border-box;
    border-radius: 3px;
    border: 1px solid #d2d2d2;
    font-weight: normal;
    background-color: #f1f1f1;
  }

  .custom-image-repeat-block .d-flex {
    flex-direction: row;
    justify-content: space-between !important;
  }
  
  .custom-image-repeat-block h2 {
    font-size: 26px;
    text-align: left;
    line-height: 30px;
  }

  .custom-image-repeat-block p {
    color: #696969;
    margin-right: 30px;
  }

  .canvaswrap{
    margin: 0 30px 60px 0;
    position: relative;
  }

  .canvaswrap .inches {
    position: absolute;
    font-weight: bold;
  }

  .canvaswrap .inches.v-36{
    top: 0;
    right: -30px;
  }

  .canvaswrap .inches.v-0 {
    bottom: 0;
    right: -30px;
  }

  .canvaswrap .inches.h-54 {
    bottom: -30px;
    right: 0px;
  }

  .canvaswrap .inches.h-0 {
    bottom: -30px;
    left: 0px;
  }

  @media only screen and (max-width: 767px) {
    .container-desktop{
      display: none !important;
    }

    .container-mobile{
      display: flex !important;
    }
  }
  @media only screen and (max-width: 1024px) {
		.custom_image_upload .row .col-lg-12 {
			-webkit-box-flex: 0;
			flex: 0 0 100%;
			max-width: 100%;
			margin-bottom: 16px;
    }

    .singlecontent {
      margin: 0 !important;
      max-width: 100%;
    }

    .singlecontent h2 {
      display: block !important;
      font-size: 22px;
    }

    .sigleproduct .fixedbar .AddTOCartBtn {
      width: 250px !important;
    }

    .sigleproduct .fixedbar .ordertype.yard, .sigleproduct .ordertype {
      margin-top: 0 !important;
    }

    .sigleproduct .fixedbar .samediv.quantity {
      margin-right: 25px;
      width: auto;
    }

    .custom_image_upload .image-repeat {
      height: 487px;
      width: 729px;
    }

    .custom-image-repeat-block .d-flex {
      flex-direction: column;
    }

    .custom-image-repeat-block h2 {
      font-size: 22px;
    }

    .custom-image-repeat-block p {
      text-align: left;
    }
	}
  @media only screen and (max-width: 1199px) and (min-width: 1025px) {
    .sigleproduct .fixedbar .AddTOCartBtn {
      width: 45.8% !important;
    }
  }

</style>
